import { Input, Component, EventEmitter, Output } from "@angular/core";

@Component({
  selector: "border-editor",
  templateUrl: "./border-editor.component.html",
})
export class BorderEditorComponent {
  @Input()
  style: Object = {
    "border-width": "1px",
    "border-color": "#000000",
  };

  @Output() styleChange = new EventEmitter();

  applyBorders(borders) {
    this.style["borders"] = borders;
    this.constructBorders();
  }

  colorChanged($event) {
    this.style["border-color"] = $event.color.hex;
    console.log("color changed", $event.color.hex, this.style["border-color"]);
    this.constructBorders();
  }

  constructBorders() {
    var borders = [
      "border-left",
      "border-right",
      "border-top",
      "border-bottom",
    ];
    borders.forEach((border) => {
      if (this.style["borders"].indexOf(border) > -1) {
        this.style[`${border}-width`] = "thin";
        this.style[`${border}-color`] = this.style["border-color"] || "#000000";
      } else {
        this.style[`${border}-width`] = 0;
        this.style[`${border}-color`] = "rgba(0, 0, 0, 0)";
      }
    });

    console.log(this.style);
    this.styleChange.emit(this.style);
  }
}
